import { formatDate } from '@/lib/utils/date';

/**
 * The legacy backend accepts expiry timestamps as
 *   "YYYY-MM-DD 23:59:59"
 * with the time fixed at end-of-day. Preserve that contract so the new
 * frontend stays wire-compatible with java_backend during the migration.
 */
export function toLegacyExpiry(date: Date | string | null | undefined): string {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return '';
  return `${formatDate(d)} 23:59:59`;
}

/**
 * Parse legacy "YYYY-MM-DD HH:MM:SS" (or "YYYY-MM-DDTHH:MM:SS") strings
 * back into a Date for use with `<DatePicker>`. Returns `undefined` on
 * unparseable input.
 */
export function fromLegacyExpiry(value: string | null | undefined): Date | undefined {
  if (!value) return undefined;
  const d = new Date(value.replace(' ', 'T'));
  return Number.isNaN(d.getTime()) ? undefined : d;
}

/**
 * Coerce any value (number, string, null, undefined) into a string for
 * use as a form input value. Backend responses can return numeric
 * fields like `pincode`, `channels`, `number` (phone) as JS numbers,
 * which would fail string-typed zod validators if passed directly into
 * react-hook-form. Always run wire values through this at the prefill
 * boundary.
 */
export function asFormString(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return '';
}
